import { z } from 'zod'

const formValidation = () => {
  const requestForm = document.querySelector('.request_form')
  const seminarForm = document.querySelector('.seminar_form')
  const consultationForm = document.querySelector('.consultation_form')

  if (requestForm || seminarForm || consultationForm) {
    const requiredSchema = z
      .string({
        required_error: '必須項目です。',
      })
      .nonempty('必須項目です。')
    const nameSchema = z
      .string()
      .regex(
        /^[々〇〻〱ヽゝ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\u3005]+$|^$/,
        '英数字は入力できません。'
      )
      .nonempty('必須項目です。')
    const nameKanaSchema = z
      .string({
        required_error: '必須項目です。',
        invalid_type_error: '全角カタカナで入力してください。',
      })
      .regex(/^[\u30A0-\u30FF]+$|^$/, '全角カタカナで入力してください。')
      .nonempty('必須項目です。')
    const zip1Schema = z
      .string({
        required_error: '必須項目です。',
        invalid_type_error: '半角数字３桁で入力してください。',
      })
      .nonempty('必須項目です。')
      .regex(/^[0-9]{3}$|^$/, '半角数字３桁で入力してください。')
    const zip2Schema = z
      .string({
        required_error: '必須項目です。',
        invalid_type_error: '半角数字４桁で入力してください。',
      })
      .nonempty('必須項目です。')
      .regex(/^[0-9]{4}$|^$/, '半角数字４桁で入力してください。')
    const addressSchema = z
      .string()
      .nonempty('必須項目です。')
      .regex(/^[^ -~｡-ﾟ]+$|^$/, '全角文字で入力してください。')
    const companySchema = z
      .string({
        required_error: "必須項目です。",
      })
      .nonempty("必須項目です。")
      .regex(/^[^ -~｡-ﾟ]+$|^$/, "全角文字で入力してください。");
    const buildingSchema = z
      .string()
      .regex(/^[^ -~｡-ﾟ]+$|^$/, '全角文字で入力してください。')
    const tel1Schema = z
      .string({
        required_error: '必須項目です。',
        invalid_type_error: '半角数字で入力してください。',
      })
      .nonempty('必須項目です。')
      .min(2, '入力文字数が少ないです。')
      .max(5, '入力文字数が多いです。')
      .regex(/^[0-9]+$|^$/, '半角数字で入力してください。')
    const tel2Schema = z
      .string({
        required_error: '必須項目です。',
        invalid_type_error: '正しい値を入力してください。',
      })
      .nonempty('必須項目です。')
      .regex(/^[0-9]+$|^$/, '半角数字で入力してください。')
      .min(1, '入力文字数が少ないです。')
      .max(4, '入力文字数が多いです。')
    const tel3Schema = z
      .string({
        required_error: '必須項目です。',
        invalid_type_error: '正しい値を入力してください。',
      })
      .nonempty('必須項目です。')
      .regex(/^[0-9]+$|^$/, '半角数字で入力してください。')
      .min(4, '入力文字数が少ないです。')
      .max(4, '入力文字数が多いです。')
    const emailSchema = z
      .string({
        required_error: '必須項目です。',
        invalid_type_error: '正しい値を入力してください。',
      })
      .nonempty('必須項目です。')
      .email('正しい値を入力してください。')
    const yearSchema = z
      .string({
        invalid_type_error: '半角数字４桁で入力してください。',
      })
      .regex(/^[0-9]{4}$|^$/, '半角数字４桁で入力してください。')
      .regex(/^2[0-9]{3}$|^$/, '正しい値を入力してください。')
    const monthSchema = z
      .string({
        invalid_type_error: '正しい値を入力してください。',
      })
      .regex(/^[0-9]+$|^$/, '半角数字で入力してください。')
      .regex(
        /^0[1-9]{1}$|^1[0-2]{1}$|^[0-9]{1}$|^$/,
        '正しい値を入力してください。'
      )
    const currentIndustryOtherSchema = z
      .string()
      .regex(/^[^ -~｡-ﾟ]+$|^$/, '全角文字で入力してください。')
    const mainBusinessOtherSchema = z
      .string()
      .regex(/^[^ -~｡-ﾟ]+$|^$/, '全角文字で入力してください。')

    let form

    if (requestForm) {
      form = requestForm
    } else if (seminarForm) {
      form = seminarForm
    } else if (consultationForm) {
      form = consultationForm
    }

    const formId = form.getAttribute('data-hash')
    const url = location.origin + location.pathname

    const destination1 = document.getElementById('destination_1'),
      destination2 = document.getElementById('destination_2'),
      lastName = document.querySelector('input[name="last_name"]'),
      firstName = document.querySelector('input[name="first_name"]'),
      lastNameKana = document.querySelector('input[name="last_name_kana"]'),
      firstNameKana = document.querySelector('input[name="first_name_kana"]'),
      company = document.querySelector('input[name="company"]'),
      companyNone = document.querySelector('input[name="company_none"]'),
      zip1 = document.querySelector('input[name="zip1"]'),
      zip2 = document.querySelector('input[name="zip2"]'),
      prefecture = document.querySelector('select[name="prefecture"]'),
      address = document.querySelector('input[name="address"]'),
      building = document.querySelector('input[name="building"]'),
      tel1 = document.querySelector('input[name="tel1"]'),
      tel2 = document.querySelector('input[name="tel2"]'),
      tel3 = document.querySelector('input[name="tel3"]'),
      email = document.querySelector('input[name="email"]'),
      license1 = document.getElementById('license_1'),
      license2 = document.getElementById('license_2'),
      privacy = document.getElementById('privacy'),
      openY = document.getElementById('open_y'),
      openM = document.getElementById('open_m'),
      openNone = document.getElementById('open_none'),
      openCompany = document.getElementById('open_company'),
      openCity = document.querySelector('select[name="open_city"]'),
      openCityNone = document.getElementById('open_city_none'),
      // formBtn = document.getElementsByClassName('form_btn')[0],
      submitBtn = document.querySelector('.submit-btn'),
      lectureDate = document.querySelectorAll('input[name="lecture_date"]'),
      consultation1 = document.getElementById('consultation1'),
      consultation2 = document.getElementById('consultation2'),
      consultationContents = document.querySelectorAll(
        'input[name="consultation_content[]"]'
      ),
      consultationElse = document.getElementById('consultation_content_else'),
      //追加
      consultationDate1 = document.getElementById('consultation_date_1'),
      consultationDate2 = document.getElementById('consultation_date_2'),
      consultationDate3 = document.getElementById('consultation_date_3'),
      howtoConsultation1 = document.getElementById('howto_consultation_1'),
      howtoConsultation2 = document.getElementById('howto_consultation_2'),
      workExperience1 = document.getElementById('work_experience_1'),
      workExperience2 = document.getElementById('work_experience_2'),
      qualification1 = document.getElementById('qualification_1'),
      qualification2 = document.getElementById('qualification_2'),
      currentIndustrys = document.querySelectorAll('input[name="current_industry[]"]'),
      currentIndustry1 = document.getElementById('current_industry_1'),
      currentIndustry2 = document.getElementById('current_industry_2'),
      currentIndustry3 = document.getElementById('current_industry_3'),
      currentIndustryOther = document.getElementById('current_industry_other'),
      mainBusinesss = document.querySelectorAll('input[name="main_business[]"]'),
      mainBusiness1 = document.getElementById('main_business_1'),
      mainBusiness2 = document.getElementById('main_business_2'),
      mainBusiness3 = document.getElementById('main_business_3'),
      mainBusiness4 = document.getElementById('main_business_4'),
      mainBusiness5 = document.getElementById('main_business_5'),
      mainBusiness6 = document.getElementById('main_business_6'),
      mainBusinessOther = document.getElementById('main_business_other'),
      consultationContent = document.getElementById('consultation_text');

    const requireds = [prefecture];

    const removeError = (el) => {
      el.classList.remove('is-invalid')
      const parent = el.parentElement
      const errors = parent.querySelectorAll('.invalid-feedback')
      errors.forEach((error) => {
        error.remove()
      });
    }
    const errorMessage = (el, issues) => {
      el.classList.add('is-invalid')
      issues.forEach((e) => {
        el.insertAdjacentHTML(
          'afterend',
          `<div class="invalid-feedback d-block">${e.message}</div>`
        )
      });
    }

    requireds.forEach((el) => {
      el.addEventListener('change', (event) => {
        removeError(el)

        try {
          requiredSchema.parse(event.target.value)
        } catch (error) {
          errorMessage(el, error.issues)
        }
      })
    });

    const validation = (el, schema) => {
      el.addEventListener('change', (event) => {
        removeError(el)

        try {
          schema.parse(event.target.value)
        } catch (error) {
          errorMessage(el, error.issues)
        }
      })
    }

    companyNone.addEventListener('change', (e) => {
      removeError(company);

      if (!e.target.checked) {
        try {
          companySchema.parse(company.value);
        } catch (error) {
          errorMessage(company, error.issues);
        }
      }
    })

    validation(firstName, nameSchema)
    validation(lastName, nameSchema)
    validation(firstNameKana, nameKanaSchema)
    validation(lastNameKana, nameKanaSchema)
    validation(company, companySchema)
    validation(zip1, zip1Schema)
    validation(zip2, zip2Schema)
    validation(address, addressSchema)
    validation(building, buildingSchema)
    validation(tel1, tel1Schema)
    validation(tel2, tel2Schema)
    validation(tel3, tel3Schema)
    validation(email, emailSchema)

    const destHidden = document.querySelector('.destination-hidden');

    [destination1, destination2].forEach((el) => {
      el?.addEventListener('change', () => {
        if (destination1.checked) {
          destHidden.classList.add('is-inactive');
          [license1, license2].forEach((el) => {
            el.checked = false
          });
          [openY, openM, openCompany].forEach((el) => {
            el.value = null
          });
          openCity.options[0].selected = true;
          [openNone, openCityNone].forEach((el) => {
            el.checked = false
            el.disabled = false
          });
        } else {
          destHidden.classList.remove('is-inactive')
        }
      })
    });

    if (destination1 && destination2) {
      if (destination1.checked) {
        destHidden.classList.add('is-inactive');
        [license1, license2].forEach((el) => {
          el.checked = false
        });
        [openY, openM, openCompany].forEach((el) => {
          el.value = null
        });
        openCity.options[0].selected = true;
        [openNone, openCityNone].forEach((el) => {
          el.checked = false
          el.disabled = false
        });
      } else {
        destHidden.classList.remove('is-inactive')
      }
    }

    [openY].forEach((el) => {
      validation(el, yearSchema)
    });
    [openM].forEach((el) => {
      validation(el, monthSchema)
    });

    openNone.addEventListener('change', () => {
      if (openNone.checked) {
        openY.disabled = true
        openM.disabled = true
      } else {
        openY.disabled = false
        openM.disabled = false
      }
    })

    if (openNone.checked) {
      openY.disabled = true
      openM.disabled = true
    } else {
      openY.disabled = false
      openM.disabled = false
    }

    [openY, openM].forEach((el) => {
      el.addEventListener('change', () => {
        if (openY.value || openM.value) {
          openNone.disabled = true
        } else {
          openNone.disabled = false
        }
      })
    });

    if (openY.value || openM.value) {
      openNone.disabled = true
    } else {
      openNone.disabled = false
    }

    openCityNone.addEventListener('change', () => {
      if (openCityNone.checked) {
        openCity.options[0].selected = true
        openCity.disabled = true
      } else {
        openCity.disabled = false
      }
    })

    if (openCityNone.checked) {
      openCity.options[0].selected = true
      openCity.disabled = true
    } else {
      openCity.disabled = false
    }

    companyNone.addEventListener('change', () => {
      if (companyNone.checked) {
        company.disabled = true
      } else {
        company.disabled = false
      }
    })

    if (companyNone.checked) {
      company.disabled = true
    } else {
      company.disabled = false
    }

    company.addEventListener('change', () => {
      if (company.value) {
        companyNone.disabled = true
      } else {
        companyNone.disabled = false
      }
    })

    const buttonsAndTextControl = (buttons, text) => {
      buttons.forEach(el => {
        el.classList.toggle('is-checked', el.checked);

        el.addEventListener('click', () => {
          const checkedEl = buttons.find(el => el.classList.contains('is-checked'));

          if (checkedEl) {
            checkedEl.checked = false;
            checkedEl.classList.remove('is-checked');

            if (el !== checkedEl) {
              el.classList.add('is-checked');
            }
          } else {
            el.classList.add('is-checked');
          }

          text.disabled = buttons.some(el => el.classList.contains('is-checked'));
        })
      })

      text.disabled = buttons.some(el => el.classList.contains('is-checked'));

      if (text.value) {
        buttons.map(el => el.disabled = true)
      }

      text.addEventListener('change', () => {
        if (text.value) {
          buttons.map(el => el.disabled = true)
        } else {
          buttons.map(el => el.disabled = false)
        }
      })
    }

    if (consultationForm) {
      // buttonsAndTextControl([currentIndustry1, currentIndustry2, currentIndustry3], currentIndustryOther);
      // buttonsAndTextControl([mainBusiness1, mainBusiness2, mainBusiness3, mainBusiness4, mainBusiness5, mainBusiness6], mainBusinessOther);
    }

    const consultationHidden = document.querySelector('.consultation-hidden');

    [consultation1, consultation2].forEach((el) => {
      el?.addEventListener('change', () => {
        if (consultation1.checked) {
          consultationHidden.classList.remove('is-inactive')
        } else {
          consultationHidden.classList.add('is-inactive')
          consultationContents.forEach((el) => {
            el.checked = false
          })
          consultationElse.value = null
        }
      })
    });

    if (consultation1 && consultation2) {
      if (consultation1.checked) {
        consultationHidden.classList.remove('is-inactive')
      } else {
        consultationHidden.classList.add('is-inactive')
        consultationContents.forEach((el) => {
          el.checked = false
        });
        consultationElse.value = null
      }
    }

    [zip1, zip2].forEach((el) => {
      el.onkeyup = null
      el.addEventListener('change', () => {
        const zip1Flag = zip1Schema.safeParse(zip1.value).success
        const zip2Flag = zip2Schema.safeParse(zip2.value).success

        if (zip1Flag && zip2Flag) {
          fetch(
            'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' +
            zip1.value +
            zip2.value
          )
            .then((res) => res.json())
            .then((data) => {
              const { address1, address2, address3 } = data.results[0]
              prefecture.value = address1
              address.value = address2 + address3;
              [prefecture, address].forEach((el) => {
                removeError(el)
              })

              try {
                requiredSchema.parse(prefecture.value)
              } catch (error) {
                errorMessage(prefecture, error.issues)
              }

              try {
                addressSchema.parse(address.value)
              } catch (error) {
                errorMessage(address, error.issues)
              }
            })
        }
      })
    });

    privacy.checked ? (submitBtn.disabled = false) : (submitBtn.disabled = true)

    privacy.addEventListener('change', () => {
      privacy.checked
        ? (submitBtn.disabled = false)
        : (submitBtn.disabled = true)
    })

    const buttonChecked = (children, parent) => {
      const frags = children.map((el) => el.checked)
      const frag = frags.some((bool) => bool)

      const errors = parent.querySelectorAll('.invalid-feedback')
      errors.forEach((error) => {
        error.remove()
      });

      if (!frag) {
        parent.insertAdjacentHTML(
          'beforeend',
          `<div class="invalid-feedback d-block">必須項目です。</div>`
        )
      }
    }

    const buttonCheckedWithText = (children, text, textScheme, parent) => {
      const frags = children.map((el) => el.checked)
      const frag = frags.some((bool) => bool)

      const errors = parent.querySelectorAll('.invalid-feedback')
      errors.forEach((error) => {
        error.remove()
      });

      if (textScheme) {
        removeError(text);

        try {
          textScheme.parse(text.value)
        } catch (error) {
          errorMessage(text, error.issues)
        }
      }

      if (!frag && !text.value) {
        parent.insertAdjacentHTML(
          'beforeend',
          `<div class="invalid-feedback d-block">必須項目です。</div>`
        )
      }
    }

    const licenseParent = license1.closest('.form-group__field');

    [license1, license2].forEach((el) => {
      el.addEventListener('change', () => {
        buttonChecked([license1, license2], licenseParent)
      })
    });

    const desParent = destination1?.closest('.form-group__field')

    const lectureDateParent = lectureDate[0]?.closest('.form-group__field')
    const consulationParent = consultation1?.closest('.form-group__field')
    const howtoConsultationParent = howtoConsultation1?.closest('.form-group__field')
    const workExperienceParent = workExperience1?.closest('.form-group__field')
    const qualificationParent = qualification1?.closest('.form-group__field')
    const currentIndustryParent = currentIndustrys[0]?.closest('.form-group__field')
    const mainBusinessParent = mainBusinesss[0]?.closest('.form-group__field')
    const consulationContentParent =
      consultationContents[0]?.closest('.form-group__field')

    if (requestForm) {
      [destination1, destination2].forEach((el) => {
        el.addEventListener('change', () => {
          buttonChecked([destination1, destination2], desParent)
        })
      });
    } else if (seminarForm || consultationForm) {
      if (seminarForm) {
        lectureDate.forEach((el) => {
          el.addEventListener('change', () => {
            buttonChecked([...lectureDate], lectureDateParent)
          })
        });

        [consultation1, consultation2].forEach((el) => {
          el.addEventListener('change', () => {
            buttonChecked([consultation1, consultation2], consulationParent)
          })
        });
        consultationContents.forEach((el) => {
          el.addEventListener('change', () => {
            buttonChecked([...consultationContents], consulationContentParent)
          })
        });
      }

      if (consultationForm) {
        const consultationDates = [consultationDate1, consultationDate2, consultationDate3];

        consultationDates.forEach(select => {
          select.addEventListener("change", updateDuplicates);
        });

        function updateDuplicates(e) {
          const valueMap = {};

          consultationDates.forEach(select => {
            removeError(select);

            const value = select.value;
            if (value === "") return;

            if (!valueMap[value]) {
              valueMap[value] = [];
            }
            valueMap[value].push(select);
          });

          [consultationDate1, consultationDate2].forEach((el) => {
            if (el === e.currentTarget) {
              try {
                requiredSchema.parse(e.target.value)
              } catch (error) {
                errorMessage(e.target, error.issues)
              }
            }
          });

          const duplicates = Object.values(valueMap).filter(group => group.length > 1);

          duplicates.forEach(group => {
            group.forEach(select => {
              errorMessage(select, [{ message: '同じ日程は選択できません。' }]);
            });
          });
        }

        [howtoConsultation1, howtoConsultation2].forEach((el) => {
          el.addEventListener('change', () => {
            buttonChecked([howtoConsultation1, howtoConsultation2], howtoConsultationParent)
          })
        });

        [workExperience1, workExperience2].forEach((el) => {
          el.addEventListener('change', () => {
            buttonChecked([workExperience1, workExperience2], workExperienceParent)
          })
        });

        [qualification1, qualification2].forEach((el) => {
          el.addEventListener('change', () => {
            buttonChecked([qualification1, qualification2], qualificationParent)
          })
        });

        [...currentIndustrys, currentIndustryOther].forEach((el) => {
          el.addEventListener('change', () => {
            buttonCheckedWithText([...currentIndustrys], currentIndustryOther, currentIndustryOtherSchema, currentIndustryParent)
          })
        });

        [...mainBusinesss, mainBusinessOther].forEach((el) => {
          el.addEventListener('change', () => {
            buttonCheckedWithText([...mainBusinesss], mainBusinessOther, mainBusinessOtherSchema, mainBusinessParent)
          })
        });
      }
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault()
      const results = []

      const pushSuccess = (el, schema) => {
        const result = schema.safeParse(el.value).success
        results.push(result)
        if (!result) {
          removeError(el)

          try {
            schema.parse(el.value)
          } catch (error) {
            errorMessage(el, error.issues)
          }
        }
      }

      if (requestForm) {
        const destinationResult = destination1.checked || destination2.checked
        results.push(destinationResult)
        destinationResult ||
          buttonChecked([destination1, destination2], desParent)

        if (!destination1.checked) {
          pushSuccess(openY, yearSchema)
          pushSuccess(openM, monthSchema)

          const licenseResult = license1.checked || license2.checked
          results.push(licenseResult)
          licenseResult || buttonChecked([license1, license2], licenseParent)
        }
      } else if (seminarForm || consultationForm) {
        if (seminarForm) {
          const lectureDateResult = [...lectureDate].some((el) => el.checked)
          results.push(lectureDateResult)
          lectureDateResult || buttonChecked([...lectureDate], lectureDateParent)

          const consultationResult =
            consultation1.checked || consultation2.checked
          results.push(consultationResult)
          consultationResult ||
            buttonChecked([consultation1, consultation2], consulationParent)

          if (consultation1.checked) {
            const consultationContentsResult = [...consultationContents].some(
              (el) => el.checked
            )
            results.push(consultationContentsResult)
            consultationContentsResult ||
              buttonChecked([...consultationContents], consulationContentParent)
          }
        }

        if (consultationForm) {
          pushSuccess(consultationDate1, requiredSchema);
          pushSuccess(consultationDate2, requiredSchema);

          const consultationDateResult = !consultationDate1.classList.contains('is-invalid') && !consultationDate2.classList.contains('is-invalid') && !consultationDate3.classList.contains('is-invalid');
          results.push(consultationDateResult);

          const howtoConsultationResult = howtoConsultation1.checked || howtoConsultation2.checked;
          results.push(howtoConsultationResult);
          howtoConsultationResult ||
            buttonChecked([howtoConsultation1, howtoConsultation2], howtoConsultationParent)

          const workExperienceResult = workExperience1.checked || workExperience2.checked;
          results.push(workExperienceResult);
          workExperienceResult ||
            buttonChecked([workExperience1, workExperience2], workExperienceParent)

          const qualificationResult = qualification1.checked || qualification2.checked;
          results.push(qualificationResult);
          qualificationResult ||
            buttonChecked([qualification1, qualification2], qualificationParent)

          pushSuccess(currentIndustryOther, currentIndustryOtherSchema);
          const currentIndustrysResult = [...currentIndustrys].some((el) => el.checked) || currentIndustryOther.value;
          results.push(currentIndustrysResult)
          currentIndustrysResult ||
            buttonCheckedWithText([...currentIndustrys], currentIndustryOther, currentIndustryOtherSchema, currentIndustryParent)

          pushSuccess(mainBusinessOther, mainBusinessOtherSchema);
          const mainBusinesssResult = [...mainBusinesss].some((el) => el.checked) || mainBusinessOther.value;
          results.push(mainBusinesssResult)
          mainBusinesssResult ||
            buttonCheckedWithText([...mainBusinesss], mainBusinessOther, mainBusinessOtherSchema, mainBusinessParent)
        }

        pushSuccess(openY, yearSchema)
        pushSuccess(openM, monthSchema)

        const licenseResult = license1.checked || license2.checked
        results.push(licenseResult)
        licenseResult || buttonChecked([license1, license2], licenseParent)
      }

      const requiredResults = requireds.map((el) => {
        const flag = requiredSchema.safeParse(el.value).success
        if (!flag) {
          removeError(el)
          try {
            requiredSchema.parse(el.value)
          } catch (error) {
            errorMessage(el, error.issues)
          }
        }
        return flag
      })

      results.push(...requiredResults)

      pushSuccess(firstName, nameSchema)
      pushSuccess(lastName, nameSchema)
      pushSuccess(firstNameKana, nameKanaSchema)
      pushSuccess(lastNameKana, nameKanaSchema)
      pushSuccess(zip1, zip1Schema)
      pushSuccess(zip2, zip2Schema)
      pushSuccess(address, addressSchema)
      pushSuccess(building, buildingSchema)
      pushSuccess(tel1, tel1Schema)
      pushSuccess(tel2, tel2Schema)
      pushSuccess(tel3, tel3Schema)
      pushSuccess(email, emailSchema)

      if (!companyNone.checked) {
        pushSuccess(company, companySchema);
      }

      const privacyResult = privacy.checked

      results.push(privacyResult)

      const frag = results.every((result) => result)

      if (frag) {
        form.submit()
      } else {
        location.href = url + '#' + formId
      }
    })
  }
}

export default formValidation
